/* tslint:disable */
/* eslint-disable */
export enum InvoiceStateType {
  Waiting = 'waiting',
  Rejected = 'rejected',
  Closed = 'closed',
  Error = 'error'
}
